import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Panel } from 'rsuite';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../containers/inventory/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import ResultHeader from './ResultHeader';
import DonorSummaryList from '../../../../components/inventory/reports/DonorSummaryList';
import DonorSummarySearchForm from '../../../../components/inventory/reports/DonorSummarySearchForm';
import {
  getIsFetched,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/donor-summary';

export default () => {
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  return (
    <PageLayout>
      <PageHeader title="Donor Summary Report">
        <DonorSummarySearchForm />
      </PageHeader>
      <Content>
        {isFetching && <ContentLoader />}
        {isFetched && (
          <Panel bodyFill bordered header={<ResultHeader />}>
            <DonorSummaryList />
          </Panel>
        )}
      </Content>
    </PageLayout>
  );
};
